/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ResolvedRuleSource } from './ResolvedRuleSource';
import {
    ResolvedRuleSourceFromJSON,
    ResolvedRuleSourceFromJSONTyped,
    ResolvedRuleSourceToJSON,
    ResolvedRuleSourceToJSONTyped,
} from './ResolvedRuleSource';

/**
 * 
 * @export
 * @interface ResolvedRuleRow
 */
export interface ResolvedRuleRow {
    /**
     * 
     * @type {string}
     * @memberof ResolvedRuleRow
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ResolvedRuleRow
     */
    body: string;
    /**
     * 
     * @type {ResolvedRuleSource}
     * @memberof ResolvedRuleRow
     */
    source: ResolvedRuleSource;
}



/**
 * Check if a given object implements the ResolvedRuleRow interface.
 */
export function instanceOfResolvedRuleRow(value: object): value is ResolvedRuleRow {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function ResolvedRuleRowFromJSON(json: any): ResolvedRuleRow {
    return ResolvedRuleRowFromJSONTyped(json, false);
}

export function ResolvedRuleRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolvedRuleRow {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'body': json['body'],
        'source': ResolvedRuleSourceFromJSON(json['source']),
    };
}

export function ResolvedRuleRowToJSON(json: any): ResolvedRuleRow {
    return ResolvedRuleRowToJSONTyped(json, false);
}

export function ResolvedRuleRowToJSONTyped(value?: ResolvedRuleRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'body': value['body'],
        'source': ResolvedRuleSourceToJSON(value['source']),
    };
}

